import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const questions = [
  // === LIVELLO 1 — ELEMENTARE (domande 1-4) ===
  { q: "Cos'è un 'link' su internet?", opts: ["Un collegamento che ti porta a un'altra pagina", "Un tipo di virus informatico", "Un programma per scrivere email", "Una password segreta"], correct: 0, level: 1 },
  { q: "Cos'è Google?", opts: ["Un social network come Facebook", "Un'app per messaggi", "Un marchio di telefoni", "Un motore di ricerca per trovare informazioni"], correct: 3, level: 1 },
  { q: "Cosa succede se clicchi su un allegato da un mittente sconosciuto?", opts: ["Niente, è sempre sicuro", "Potrebbe essere un virus o una truffa", "Si apre Google automaticamente", "Il telefono si ricarica più veloce"], correct: 1, level: 1 },
  { q: "Cos'è Wikipedia?", opts: ["Un motore di ricerca concorrente di Google", "Un social network per studenti", "Un'enciclopedia libera online scritta da volontari", "Un'app per guardare video"], correct: 2, level: 1 },
  // === LIVELLO 2 — MEDIE (domande 5-8) ===
  { q: "Cos'è una 'password sicura'?", opts: ["Il tuo nome e cognome", "La stessa che usi ovunque", "1234567890", "Una combinazione lunga con lettere, numeri e simboli"], correct: 3, level: 2 },
  { q: "WhatsApp, Instagram e TikTok sono di proprietà di:", opts: ["Meta (WhatsApp, Instagram) e ByteDance (TikTok)", "Google, Apple e Microsoft", "Samsung e Huawei", "Lo Stato Italiano"], correct: 0, level: 2 },
  { q: "Cosa significa 'scaricare un file' sul telefono?", opts: ["Cancellarlo definitivamente", "Metterlo in carica", "Copiarlo da internet nella memoria del dispositivo", "Inviarlo a un amico"], correct: 2, level: 2 },
  { q: "Cos'è il 'cloud'?", opts: ["Un tipo di connessione WiFi", "Un sistema operativo", "Una marca di computer", "Uno spazio di archiviazione online accessibile da qualsiasi dispositivo"], correct: 3, level: 2 },
  // === LIVELLO 3 — SUPERIORI (domande 9-12) ===
  { q: "Cos'è l'HTML?", opts: ["Un programma antivirus", "Il linguaggio con cui si costruiscono le pagine web", "Un social network professionale", "Un tipo di connessione internet"], correct: 1, level: 3 },
  { q: "Cos'è un 'cookie' nel contesto web?", opts: ["Un piccolo file che i siti salvano nel browser per ricordare le tue preferenze", "Un virus molto pericoloso", "Un tipo di pubblicità online", "Un'email indesiderata"], correct: 0, level: 3 },
  { q: "Cosa significa 'SEO'?", opts: ["Social Entertainment Online", "Sistema Elettronico Operativo", "Secure Email Output", "Search Engine Optimization — ottimizzazione per i motori di ricerca"], correct: 3, level: 3 },
  { q: "Un sito web con 'https://' invece di 'http://' significa che:", opts: ["È più veloce", "Non funziona su mobile", "La connessione è crittografata e più sicura", "È un sito governativo"], correct: 2, level: 3 },
  // === LIVELLO 4 — UNIVERSITÀ (domande 13-14) ===
  { q: "Cos'è un 'prompt' nell'intelligenza artificiale?", opts: ["La schermata di login", "Il pulsante di accensione del computer", "Un tipo di virus", "Un comando o istruzione testuale data a un modello AI per ottenere una risposta"], correct: 3, level: 4 },
  { q: "Quale di queste è un'intelligenza artificiale generativa?", opts: ["ChatGPT di OpenAI", "Microsoft Excel", "Google Maps", "Windows 11"], correct: 0, level: 4 },
  // === LIVELLO 4/5 — ESPERTO (domande 15-20) ===
  { q: "Cos'è il 'machine learning'?", opts: ["Un corso online per imparare a usare il PC", "Un ramo dell'AI dove le macchine vengono programmate con regole esplicite per ogni scenario", "Un ramo dell'AI dove le macchine imparano dai dati senza essere programmate esplicitamente", "Un tipo di hardware per computer", "Un sistema operativo per robot"], correct: 2, level: 4 },
  { q: "Nel marketing digitale, cos'è il 'conversion rate'?", opts: ["La velocità di caricamento del sito", "La percentuale di utenti unici che visitano il sito in un mese", "Il numero di follower su Instagram", "La percentuale di visitatori che compiono l'azione desiderata (acquisto, iscrizione, ecc.)", "Il costo di una campagna pubblicitaria diviso per i click"], correct: 3, level: 4 },
  { q: "Cos'è un 'Large Language Model' (LLM)?", opts: ["Un modello AI addestrato su enormi quantità di testo che genera linguaggio naturale", "Un modello AI addestrato su enormi quantità di immagini che genera descrizioni testuali", "Un dizionario digitale molto grande", "Un programma per tradurre lingue in tempo reale", "Un tipo di database relazionale ottimizzato per il testo"], correct: 0, level: 5 },
  { q: "Nel contesto AI, cosa significa 'fine-tuning'?", opts: ["Addestrare un modello completamente da zero su un dataset specifico", "Aggiornare il sistema operativo di un server AI", "Ri-addestrare un modello pre-esistente su dati specifici per un compito particolare", "Comprare la versione premium di un software AI", "Regolare i parametri hardware della GPU per velocizzare l'inferenza"], correct: 2, level: 5 },
  { q: "Cos'è un 'token' nel contesto di GPT e LLM?", opts: ["Una criptovaluta usata per pagare le API di OpenAI", "Una password temporanea per accedere al modello", "Un frammento di testo (parola o parte di parola) elaborato dal modello", "Un frammento di codice sorgente che il modello esegue internamente", "Un tipo di file di configurazione del modello"], correct: 2, level: 5 },
  { q: "Cos'è la 'Retrieval Augmented Generation' (RAG)?", opts: ["Una tecnica che genera testo casuale per aumentare il dataset di training", "Un sistema che combina la ricerca in documenti esterni con la generazione di testo dell'LLM", "Un sistema che cerca documenti esterni e li presenta all'utente senza generazione AI", "Un metodo per comprimere i modelli AI riducendo i parametri", "Un framework per addestrare modelli di linguaggio da zero"], correct: 1, level: 5 },
];

// === BONUS — LIVELLO 6: PROGRAMMATORE (domande 21-25) ===
const bonusQuestions = [
  { q: "Qual è la differenza principale tra REST e GraphQL?", opts: ["REST usa solo GET, GraphQL usa solo POST", "GraphQL permette al client di specificare esattamente quali dati ricevere, REST restituisce risorse fisse", "REST è più recente di GraphQL", "Non c'è differenza, sono sinonimi", "GraphQL funziona solo con database NoSQL"], correct: 1, level: 6 },
  { q: "Cosa significa O(n log n) nella complessità algoritmica?", opts: ["L'algoritmo è lineare", "L'algoritmo è esponenziale", "L'algoritmo cresce in modo quasi-lineare, tipico di sort efficienti come Merge Sort", "L'algoritmo è costante", "L'algoritmo è quadratico"], correct: 2, level: 6 },
  { q: "In Docker, qual è la differenza tra un'immagine e un container?", opts: ["Sono la stessa cosa", "L'immagine è il template immutabile, il container è un'istanza in esecuzione dell'immagine", "Il container è il template, l'immagine è l'istanza", "L'immagine gira solo su Linux, il container ovunque", "Un container può contenere più immagini contemporaneamente"], correct: 1, level: 6 },
  { q: "Cos'è una 'race condition' nella programmazione concorrente?", opts: ["Quando due thread competono per la CPU più veloce", "Quando il risultato dipende dall'ordine non-deterministico di esecuzione di operazioni concorrenti", "Quando un programma è troppo lento", "Quando due programmi hanno lo stesso nome", "Quando si usa Python invece di C++"], correct: 1, level: 6 },
  { q: "Cosa significa CI/CD nel contesto DevOps?", opts: ["Computer Intelligence / Computer Design", "Continuous Integration / Continuous Deployment — automazione di test e rilascio del software", "Cloud Infrastructure / Cloud Database", "Code Inspection / Code Debugging", "Client Interface / Client Database"], correct: 1, level: 6 },
];

const selfAssessOptions = [
  { label: 'Elementari', range: '0-10', value: 'elementari', color: '#00FF41', icon: '1' },
  { label: 'Medie', range: '10-15', value: 'medie', color: '#4ECDC4', icon: '2' },
  { label: 'Superiori', range: '18/20', value: 'superiori', color: '#FFD700', icon: '3' },
  { label: 'Master', range: '20/20', value: 'master', color: '#FF00FF', icon: 'M' },
];

const levels = [
  { name: '1a ELEMENTARE', color: '#00FF41', desc: 'Parti dalle basi: cos\'è un link, Google, Wikipedia. 10 lezioni per scoprire il digitale da zero.', weeks: '10 settimane', icon: '1' },
  { name: 'MEDIE', color: '#4ECDC4', desc: 'Social media consapevole, cloud, password sicure, cybersecurity e identità digitale.', weeks: '12 settimane', icon: '2' },
  { name: 'SUPERIORI', color: '#FFD700', desc: 'HTML/CSS, SEO, automazione, business digitale e primi passi nel freelancing.', weeks: '16 settimane', icon: '3' },
  { name: 'UNIVERSITA', color: '#FF6B6B', desc: 'AI generativa, prompt engineering, marketing digitale, data analysis e strategia.', weeks: '20 settimane', icon: '4' },
  { name: 'MASTER', color: '#FF00FF', desc: 'LLM, fine-tuning, full-stack development, leadership digitale e mentoring.', weeks: '24 settimane', icon: '5' },
  { name: 'PROGRAMMATORE', color: '#00DDFF', desc: 'Sei un professionista. Docker, CI/CD, algoritmi, architetture — ci lavori o ci sei nato dentro.', weeks: 'Livello PRO', icon: 'P' },
];

const badges = [
  { name: 'Matricola Digitale', minScore: 0, maxScore: 4, color: '#00FF41', emoji: '1', desc: 'Hai iniziato il viaggio!' },
  { name: 'Studente Curioso', minScore: 5, maxScore: 9, color: '#4ECDC4', emoji: '2', desc: 'Le basi ci sono, si cresce!' },
  { name: 'Diplomato Tech', minScore: 10, maxScore: 14, color: '#FFD700', emoji: '3', desc: 'Solida cultura digitale.' },
  { name: 'Laureato AI', minScore: 15, maxScore: 17, color: '#FF6B6B', emoji: '4', desc: 'Conosci il digitale avanzato.' },
  { name: 'Master Mind', minScore: 18, maxScore: 20, color: '#FF00FF', emoji: 'M', desc: 'Top level. Pochi ci arrivano.' },
  { name: 'Dev Certificato', minScore: 21, maxScore: 25, color: '#00DDFF', emoji: 'P', desc: 'Sei un programmatore. Rispetto.' },
];

const getBadge = (score) => badges.find(b => score >= b.minScore && score <= b.maxScore) || badges[0];

const PlacementTest = () => {
  const [phase, setPhase] = useState('selfAssess'); // selfAssess -> quiz -> bonus -> result
  const [selfAssess, setSelfAssess] = useState(null);
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [bonusMode, setBonusMode] = useState(false);
  const [bonusCurrent, setBonusCurrent] = useState(0);
  const [bonusAnswers, setBonusAnswers] = useState([]);

  useEffect(() => {
    if (phase === 'result') {
      localStorage.setItem('quiz_completed', '1');
    }
  }, [phase]);

  const allQuestions = bonusMode ? bonusQuestions : questions;
  const currentQ = bonusMode ? bonusCurrent : current;

  const handleAnswer = (optIdx) => {
    setSelected(optIdx);
    const q = allQuestions[currentQ];
    const isCorrect = q.correct === optIdx;

    setTimeout(() => {
      if (bonusMode) {
        const newBonusAnswers = [...bonusAnswers, { qIdx: bonusCurrent, selected: optIdx, correct: isCorrect }];
        setBonusAnswers(newBonusAnswers);
        setSelected(null);
        if (bonusCurrent + 1 >= bonusQuestions.length) {
          setPhase('result');
        } else {
          setBonusCurrent(bonusCurrent + 1);
        }
      } else {
        const newAnswers = [...answers, { qIdx: current, selected: optIdx, correct: isCorrect }];
        setAnswers(newAnswers);
        setSelected(null);
        if (current + 1 >= questions.length) {
          const score = newAnswers.filter(a => a.correct).length;
          if (score === 20) {
            setBonusMode(true);
            setPhase('bonusIntro');
          } else {
            setPhase('result');
          }
        } else {
          setCurrent(current + 1);
        }
      }
    }, 600);
  };

  const getResult = () => {
    const baseScore = answers.filter(a => a.correct).length;
    const bonusScore = bonusAnswers.filter(a => a.correct).length;
    const totalScore = baseScore + bonusScore;
    const totalQuestions = baseScore === 20 ? 25 : 20;

    let assignedLevel = 0;
    if (totalScore >= 21) assignedLevel = 5;
    else if (totalScore >= 17) assignedLevel = 4;
    else if (totalScore >= 13) assignedLevel = 3;
    else if (totalScore >= 9) assignedLevel = 2;
    else if (totalScore >= 5) assignedLevel = 1;

    return { score: totalScore, total: totalQuestions, baseScore, bonusScore, assignedLevel, badge: getBadge(totalScore) };
  };

  const restart = () => {
    setPhase('selfAssess');
    setSelfAssess(null);
    setCurrent(0);
    setAnswers([]);
    setSelected(null);
    setBonusMode(false);
    setBonusCurrent(0);
    setBonusAnswers([]);
  };

  useEffect(() => {
    if (phase === 'result') {
      const result = getResult();
      const level = levels[result.assignedLevel];
      axios.post(`${API_URL}/api/tests`, {
        score: result.score,
        total: result.total,
        level_assigned: level.name,
        level_index: result.assignedLevel,
        self_assessment: selfAssess,
        badge: result.badge.name,
      }).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phase]);

  // === FASE 1: AUTOVALUTAZIONE ===
  if (phase === 'selfAssess') {
    return (
      <div data-testid="placement-test" className="bg-[#0A0A0A] border border-[#00FF41]/30 p-6 sm:p-8 mb-16">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-3">Test di Piazzamento</p>
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3">Prima di iniziare...</h2>
        <p className="text-zinc-400 text-sm mb-6">Secondo te, quante ne azzeccherai su 20 domande? Sii onesto con te stesso.</p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
          {selfAssessOptions.map((opt) => (
            <button
              key={opt.value}
              onClick={() => setSelfAssess(opt.value)}
              data-testid={`self-assess-${opt.value}`}
              className={`relative p-4 border-2 rounded-xl text-center transition-all duration-300 ${
                selfAssess === opt.value ? 'scale-105' : 'hover:scale-102'
              }`}
              style={{
                borderColor: selfAssess === opt.value ? opt.color : '#333',
                background: selfAssess === opt.value ? `${opt.color}15` : 'transparent',
                boxShadow: selfAssess === opt.value ? `0 0 20px ${opt.color}30` : 'none',
              }}
            >
              <div className="w-12 h-12 rounded-full mx-auto flex items-center justify-center font-mono font-black text-lg mb-2"
                style={{ border: `3px solid ${opt.color}`, color: opt.color }}>
                {opt.icon}
              </div>
              <p className="font-black text-sm text-white mb-1">{opt.label}</p>
              <p className="font-mono text-lg font-black" style={{ color: opt.color }}>{opt.range}</p>
            </button>
          ))}
        </div>

        {selfAssess && (
          <div className="animate-fade-in">
            <p className="text-zinc-500 text-xs text-center mb-4 italic">
              {selfAssess === 'elementari' && 'Umiltà è la base dell\'apprendimento. Vediamo se ti sottovaluti!'}
              {selfAssess === 'medie' && 'Buona consapevolezza. Vediamo se hai ragione!'}
              {selfAssess === 'superiori' && 'Sicuro di te! Dimostralo nelle 20 domande.'}
              {selfAssess === 'master' && 'Wow, 20/20? Se ce la fai, ti sblocchiamo 5 domande BONUS da programmatore.'}
            </p>
            <button
              onClick={() => setPhase('quiz')}
              className="w-full bg-[#00FF41] text-black font-bold py-3 px-6 hover:bg-[#33FF66] transition-colors text-sm"
              data-testid="start-placement-test"
            >
              INIZIA IL TEST — 20 DOMANDE
            </button>
          </div>
        )}
      </div>
    );
  }

  // === FASE BONUS INTRO ===
  if (phase === 'bonusIntro') {
    return (
      <div data-testid="bonus-intro" className="bg-[#0A0A0A] border-2 border-[#00DDFF]/50 p-6 sm:p-8 mb-16">
        <div className="text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#00DDFF] mb-4 animate-pulse">LIVELLO SEGRETO SBLOCCATO</p>
          <p className="text-5xl font-black text-white mb-3">20/20</p>
          <p className="text-[#00DDFF] text-lg font-bold mb-2">Perfetto. Sei un mostro.</p>
          <p className="text-zinc-400 text-sm mb-6">Ma sei un programmatore? Abbiamo 5 domande EXTRA di livello DEV. Se fai 25/25, ti diamo il badge "Dev Certificato".</p>
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-16 h-16 rounded-xl flex items-center justify-center font-mono font-black text-2xl"
              style={{ border: '3px solid #00DDFF', color: '#00DDFF', background: '#00DDFF10', boxShadow: '0 0 30px #00DDFF30' }}>
              P
            </div>
            <div className="text-left">
              <p className="font-black text-white">Dev Certificato</p>
              <p className="text-zinc-500 text-xs">Il badge definitivo. Condividilo sui social.</p>
            </div>
          </div>
          <button
            onClick={() => { setBonusMode(true); setPhase('quiz'); }}
            className="bg-[#00DDFF] text-black font-bold py-3 px-8 hover:bg-[#33EEFF] transition-colors text-sm mr-3"
            data-testid="start-bonus"
          >
            ACCETTO LA SFIDA
          </button>
          <button
            onClick={() => setPhase('result')}
            className="border border-zinc-600 text-zinc-400 px-6 py-3 text-sm hover:border-zinc-400 transition-colors"
          >
            No grazie, 20/20 mi basta
          </button>
        </div>
      </div>
    );
  }

  // === FASE RISULTATO ===
  if (phase === 'result') {
    const result = getResult();
    const level = levels[result.assignedLevel];
    const badge = result.badge;
    const assessDiff = selfAssess === 'elementari' ? 10 : selfAssess === 'medie' ? 15 : selfAssess === 'superiori' ? 18 : 20;
    const overUnder = result.score > assessDiff ? 'over' : result.score < assessDiff ? 'under' : 'exact';

    return (
      <div data-testid="placement-result" className="bg-[#0A0A0A] border border-[#00FF41]/30 p-6 sm:p-8 mb-16">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Risultato Test</p>

        <div className="text-center mb-6">
          <p className="text-5xl font-black text-white mb-1">{result.score}<span className="text-xl text-zinc-500">/{result.total}</span></p>
          <p className="text-zinc-500 text-xs mb-2">risposte corrette</p>
          {selfAssess && (
            <p className={`text-xs font-bold ${overUnder === 'over' ? 'text-[#00FF41]' : overUnder === 'under' ? 'text-red-400' : 'text-[#FFD700]'}`}>
              {overUnder === 'over' && 'Ti sei sottovalutato! Hai fatto meglio di quanto pensavi.'}
              {overUnder === 'under' && 'Hmm, ti sei sopravvalutato un po\'. Ma imparerai!'}
              {overUnder === 'exact' && 'Azzeccato! Ti conosci bene.'}
            </p>
          )}
        </div>

        {/* BADGE */}
        <div className="border-2 rounded-2xl p-6 text-center mb-6" style={{ borderColor: badge.color, background: `${badge.color}08` }}>
          <p className="text-zinc-500 text-[10px] uppercase tracking-widest mb-3">Il tuo badge</p>
          <div className="w-24 h-24 rounded-2xl mx-auto flex items-center justify-center font-mono font-black text-3xl mb-3"
            style={{ border: `4px solid ${badge.color}`, color: badge.color, background: `${badge.color}12`, boxShadow: `0 0 40px ${badge.color}25` }}>
            {badge.emoji}
          </div>
          <p className="text-xl font-black mb-1" style={{ color: badge.color }}>{badge.name}</p>
          <p className="text-zinc-400 text-sm mb-4">{badge.desc}</p>
          <div className="flex gap-2 justify-center flex-wrap">
            <button
              onClick={() => {
                const text = `Ho ottenuto il badge "${badge.name}" (${result.score}/${result.total}) al Test Digitale di AI_COVO! Che livello sei tu? Fai il test: ${window.location.origin}/formazione`;
                try{navigator.clipboard.writeText(text).then(()=>alert('Copiato! Incollalo sui social.')).catch(()=>{const a=document.createElement('textarea');a.value=text;document.body.appendChild(a);a.select();document.execCommand('copy');document.body.removeChild(a);alert('Copiato! Incollalo sui social.')})}catch(e){const a=document.createElement('textarea');a.value=text;document.body.appendChild(a);a.select();document.execCommand('copy');document.body.removeChild(a);alert('Copiato! Incollalo sui social.')}
              }}
              className="px-4 py-2 text-xs font-bold rounded-lg transition-colors"
              style={{ background: badge.color, color: '#000' }}
              data-testid="share-badge"
            >
              CONDIVIDI SUI SOCIAL
            </button>
            <button
              onClick={() => {
                const text = `Ho ottenuto il badge "${badge.name}" (${result.score}/${result.total}) al Test Digitale di AI_COVO! 🎯`;
                const url = `https://wa.me/?text=${encodeURIComponent(text + ' ' + window.location.origin + '/formazione')}`;
                window.open(url, '_blank');
              }}
              className="px-4 py-2 text-xs font-bold rounded-lg bg-green-600 text-white hover:bg-green-500 transition-colors"
            >
              WHATSAPP
            </button>
          </div>
        </div>

        {/* Livello consigliato */}
        <div className="border p-5 text-center mb-6" style={{ borderColor: `${level.color}44`, background: `${level.color}06` }}>
          <p className="text-zinc-500 text-xs mb-2">Il tuo livello consigliato:</p>
          <p className="text-2xl font-black mb-2" style={{ color: level.color }}>{level.name}</p>
          <p className="text-zinc-400 text-sm mb-2">{level.desc}</p>
          <p className="text-zinc-600 text-xs font-mono">{level.weeks}</p>
        </div>

        <div className="flex gap-3 flex-wrap justify-center">
          <Link to="/dona" className="bg-[#00FF41] text-black font-bold px-6 py-2 text-sm hover:bg-[#33FF66] transition-colors" data-testid="placement-enroll">
            ISCRIVITI AL PERCORSO
          </Link>
          <button onClick={restart} className="border border-zinc-600 text-zinc-400 px-6 py-2 text-sm hover:border-zinc-400 transition-colors" data-testid="placement-restart">
            RIFAI IL TEST
          </button>
        </div>
      </div>
    );
  }

  // === FASE QUIZ ATTIVO ===
  const q = allQuestions[currentQ];
  const totalQ = bonusMode ? bonusQuestions.length : questions.length;
  const progress = (currentQ / totalQ) * 100;
  const correctSoFar = bonusMode
    ? answers.filter(a => a.correct).length + bonusAnswers.filter(a => a.correct).length
    : answers.filter(a => a.correct).length;
  const wrongSoFar = bonusMode
    ? answers.filter(a => !a.correct).length + bonusAnswers.filter(a => !a.correct).length
    : answers.filter(a => !a.correct).length;

  const accentColor = bonusMode ? '#00DDFF' : '#00FF41';

  return (
    <div data-testid="placement-test-active" className="bg-[#0A0A0A] border p-6 sm:p-8 mb-16" style={{ borderColor: `${accentColor}44` }}>
      <div className="flex items-center justify-between mb-1">
        <p className="font-mono text-[10px] uppercase tracking-wider" style={{ color: accentColor }}>
          {bonusMode ? `BONUS — LIVELLO DEV` : `Domanda ${currentQ + 1}`}
        </p>
        <p className="font-mono text-[10px] text-zinc-500">
          {bonusMode ? `${bonusCurrent + 1}/5 (totale: ${20 + bonusCurrent + 1}/25)` : `${currentQ + 1}/${totalQ}`}
        </p>
      </div>
      <div className="w-full h-1 bg-zinc-800 mb-6">
        <div className="h-full transition-all duration-500" style={{ width: `${progress}%`, background: accentColor }} />
      </div>

      <p className="text-white font-bold text-lg mb-6">{q.q}</p>

      <div className="space-y-2">
        {q.opts.map((opt, i) => {
          let borderColor = 'border-zinc-800 hover:border-zinc-600';
          let bg = 'bg-transparent';
          let textColor = 'text-zinc-300';

          if (selected !== null) {
            if (i === q.correct) {
              borderColor = `border-[${accentColor}]`;
              bg = `bg-[${accentColor}]/10`;
              textColor = `text-[${accentColor}]`;
            } else if (i === selected && selected !== q.correct) {
              borderColor = 'border-red-500';
              bg = 'bg-red-500/10';
              textColor = 'text-red-400';
            }
          }

          const isCorrectAnswer = selected !== null && i === q.correct;
          const isWrongSelection = selected !== null && i === selected && selected !== q.correct;

          return (
            <button
              key={i}
              onClick={() => selected === null && handleAnswer(i)}
              disabled={selected !== null}
              className={`w-full text-left p-4 border transition-all ${selected === null ? 'cursor-pointer border-zinc-800 hover:border-zinc-600' : 'cursor-default'}`}
              style={
                isCorrectAnswer ? { borderColor: accentColor, background: `${accentColor}15` } :
                isWrongSelection ? { borderColor: '#EF4444', background: '#EF444415' } :
                {}
              }
              data-testid={`placement-opt-${i}`}
            >
              <span className="font-mono text-xs text-zinc-600 mr-3">{String.fromCharCode(65 + i)}</span>
              <span className={`text-sm ${isCorrectAnswer ? '' : isWrongSelection ? 'text-red-400' : 'text-zinc-300'}`}
                style={isCorrectAnswer ? { color: accentColor } : {}}>
                {opt}
              </span>
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-4 mt-4 text-[10px] font-mono text-zinc-600">
        <span>Corrette: {correctSoFar}</span>
        <span>|</span>
        <span>Sbagliate: {wrongSoFar}</span>
      </div>
    </div>
  );
};

export default PlacementTest;
